import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import RealTimeTrackingBasicDetail from "./RealTimeTrackingComponents/RealTimeTrackingBasicDetail";

import {
  useGetRealTimeTrackingDetailQuery,
} from "store/services/realTimeTrackingApi";

import {
  RealTimeTrackingDetailContext,
  useRealTimeTrackingDetailContext,
} from "contexts/RealTimeTrackingDetailContext";

const RealTimeTrackingDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "Real-Time Tracking", path: "/app/crm/realtime-tracking/list" },
    { title: "Tracking Detail" },
  ];

  // RTK Query
  const {
    data: trackingDetail,
    isLoading: loadingTracking,
    error,
  } = useGetRealTimeTrackingDetailQuery(id);

  return (
    <RealTimeTrackingDetailContext.Provider
      value={{ trackingDetail, loadingTracking }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingTracking}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <RealTimeTrackingBasicDetail />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </RealTimeTrackingDetailContext.Provider>
  );
};

export default RealTimeTrackingDetailScreen;

const PageActions = () => {
  const { trackingDetail } = useRealTimeTrackingDetailContext();

  return (
    <div className="flex items-center gap-4">
      <Link to={`/app/crm/realtime-tracking/${trackingDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};
